import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import "./Vote.css";

const VoteLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="vote-page">
      <header className="vote-header">
        <button className="back-btn" onClick={() => navigate("/")}>
          ← بازگشت
        </button>

        <Link to="/vote" className="vote-header-brand">
          <span className="vote-brand-icon">
            <i className="fas fa-graduation-cap"></i>
          </span>
          <span>درخواست استخراج لغات</span>
        </Link>

        <nav className="vote-header-nav">
          <NavLink
            to="/vote"
            end
            className={({ isActive }) =>
              `vote-nav-link ${isActive ? "active" : ""}`
            }
          >
            <i className="fas fa-home"></i>
            خانه
          </NavLink>
          <NavLink
            to="/vote/MyVotes"
            className={({ isActive }) =>
              `vote-nav-link ${isActive ? "active" : ""}`
            }
          >
            <i className="fas fa-clipboard-list"></i>
            درخواست‌های من
          </NavLink>
          <NavLink
            to="/vote/FAQs"
            className={({ isActive }) =>
              `vote-nav-link ${isActive ? "active" : ""}`
            }
          >
            <i className="fas fa-circle-question"></i>
            سوالات متداول
          </NavLink>
        </nav>
      </header>

      <main className="vote-content">
        <Outlet />
      </main>

      <footer className="vote-footer">
        داشبورد درخواست استخراج لغات و اصطلاحات زیرنویس · UMLANG
      </footer>
    </div>
  );
};

export default VoteLayout;